// extracted by mini-css-extract-plugin
module.exports = {"titleWrapper":"HeroAreaContent-module-title-wrapper","title":"HeroAreaContent-module-title","subtitle":"HeroAreaContent-module-subtitle"};